import { Box, Stack, Typography } from '@mui/material';
import type { Booking } from '../../types';

type Props = {
  booking: Booking;
};

export default function ReservationIdentityBlock({ booking }: Props) {
  return (
    <Stack spacing={1} sx={{ minWidth: 0 }}>
      <Box>
        <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', fontWeight: 700, letterSpacing: '0.04em' }}>
          Client
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            minWidth: 0,
            fontWeight: 700,
            color: 'text.primary',
            overflowWrap: 'anywhere',
          }}
        >
          {booking.userName}
        </Typography>
      </Box>

      <Stack spacing={0.75}>
        <Stack direction="row" spacing={1.5} justifyContent="space-between" alignItems="baseline">
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Email
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 600, textAlign: 'right', overflowWrap: 'anywhere' }}>
            {booking.userEmail}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1.5} justifyContent="space-between" alignItems="baseline">
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Téléphone
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 600, textAlign: 'right', overflowWrap: 'anywhere' }}>
            {booking.userPhone || 'Non renseigné'}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1.5} justifyContent="space-between" alignItems="baseline">
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Référence
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 700, textAlign: 'right', overflowWrap: 'anywhere' }}>
            {booking.id}
          </Typography>
        </Stack>
      </Stack>

      {booking.specialNeeds ? (
        <Box
          sx={{
            p: 1,
            borderRadius: 2,
            bgcolor: 'rgba(192, 110, 82, 0.08)',
            border: '1px solid rgba(192, 110, 82, 0.16)',
          }}
        >
          <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', fontWeight: 700 }}>
            Besoin signalé
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.25, color: 'text.primary', overflowWrap: 'anywhere' }}>
            {booking.specialNeeds}
          </Typography>
        </Box>
      ) : null}
    </Stack>
  );
}
